module.exports = __webpack_public_path__ + "static/media/link.2fe12519.svg";